import React from 'react';

const categories = [
  { id: 'all', name: 'All', icon: '🎯', color: 'bg-gray-500' },
  { id: 'salon', name: 'Salon', icon: '💇', color: 'bg-pink-500' },
  { id: 'clinic', name: 'Clinic', icon: '🏥', color: 'bg-blue-500' },
  { id: 'gym', name: 'Gym', icon: '💪', color: 'bg-green-500' },
  { id: 'ride', name: 'Ride', icon: '🚗', color: 'bg-purple-500' },
];

const CategoryFilter = ({ selectedCategory, setSelectedCategory }) => {
  return (
    <div className="bg-white rounded-lg shadow-md p-4">
      <h3 className="text-sm font-medium text-gray-700 mb-3">Browse by Category</h3>
      <div className="flex flex-wrap gap-3">
        {categories.map((category) => (
          <button
            key={category.id}
            onClick={() => setSelectedCategory(category.id)}
            className={`flex items-center space-x-2 px-4 py-2 rounded-full transition-all transform hover:scale-105 ${
              selectedCategory === category.id
                ? `${category.color} text-white shadow-lg`
                : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
            }`}
          >
            <span className="text-lg">{category.icon}</span>
            <span className="font-medium">{category.name}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default CategoryFilter;